import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Save } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function ChangePassword() {
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("New password must be at least 8 characters"); return; }
    if (pw !== pw2) { toast.error("New passwords do not match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      toast.success("Password changed successfully");
      setCur(""); setPw(""); setPw2("");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail) || "Could not change password");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-lg" data-testid="change-password">
      <div className="bg-white rounded-xl border border-slate-200 p-6 space-y-4">
        <div className="flex items-center gap-3">
          <span className="h-11 w-11 rounded-xl bg-emerald-brand/10 text-emerald-brand flex items-center justify-center"><KeyRound size={20} /></span>
          <div><h3 className="font-display font-semibold text-navy">Change Password</h3><p className="text-sm text-slate-500">Update your admin login password</p></div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Current Password</Label><Input required type="password" data-testid="cp-current" className="mt-1.5" value={cur} onChange={(e) => setCur(e.target.value)} /></div>
          <div><Label>New Password</Label><Input required type="password" data-testid="cp-new" className="mt-1.5" value={pw} onChange={(e) => setPw(e.target.value)} /></div>
          <div><Label>Confirm New Password</Label><Input required type="password" data-testid="cp-new2" className="mt-1.5" value={pw2} onChange={(e) => setPw2(e.target.value)} /></div>
          <Button type="submit" disabled={loading} data-testid="cp-submit" className="bg-emerald-brand hover:bg-emerald-dark gap-1.5"><Save size={15} /> {loading ? "Saving…" : "Update Password"}</Button>
        </form>
      </div>
    </div>
  );
}
